import { css } from '@emotion/react';
import { CheckBox, t, TextBody2RRMixin, TextH3OMMixin } from '@mobalytics/shared';
import { getMoneyBaseUnit } from '../../../../payment/utils/get-money-base-unit.utils';
import { PricePerTimeframe } from '../../../../payment/payment-details/plan-details/price-per-timeframe/price-per-timeframe.component';
import { getMoneyAsString } from '../../../../payment/utils/get-money-as-string.utils';
import { CDN_IMAGES } from '../../../../../constants';

interface Props {
  className?: string;
  bundle: {
    name: string;
    price: {
      amount: number;
      currency: string;
    };
    finalPrice: {
      amount: number;
      currency: string;
    };
  };
  isChecked: boolean;
  onChange: (checked: boolean) => void;
}

export const BundleInfo: React.FC<Props> = (props) => {
  const { bundle, isChecked, onChange } = props;
  const shouldShowBasePrice =
    bundle.finalPrice.amount !== bundle.price.amount && bundle.finalPrice.amount < bundle.price.amount;
  return (
    <div css={[wrapperCss, isChecked && wrapperActiveCss]}>
      <img src={`${CDN_IMAGES}/payments/plus.png`} alt={''} css={imageCss} />
      <CheckBox
        id="bundle"
        isChecked={isChecked}
        label={<p css={checkboxCss}>{t('Add {{bundleName}} Bundle', { bundleName: bundle.name })}</p>}
        onChange={(e) => onChange(e.target.checked)}
      />

      <div css={priceWrapperCss}>
        <PricePerTimeframe
          currency={bundle.price.currency}
          price={getMoneyBaseUnit(bundle.finalPrice.amount, true)}
          timeframe={'once'}
          priceCssOverride={priceCssOverride}
          durationLabelCssOverride={durationLabelCssOverride}
        />

        {shouldShowBasePrice && (
          <p css={basePriceCss}>{getMoneyAsString(bundle.price.currency, bundle.price.amount)}</p>
        )}
      </div>
    </div>
  );
};

const wrapperCss = css`
  position: relative;
  padding: 16px;
  border: 1px solid #382f66;
  border-radius: 6px;
  background-color: #2c274f;
  transition: border-color 0.2s ease-out;
`;

const imageCss = css`
  position: absolute;
  top: 0;
  right: 0;
  object-fit: cover;
`;

const wrapperActiveCss = css`
  border-color: #1dc49b;
`;

const priceWrapperCss = css`
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

const priceCssOverride = css`
  ${TextH3OMMixin};
`;

const durationLabelCssOverride = css``;

const basePriceCss = css`
  font:
    500 16px Oswald,
    sans-serif;
  color: var(--general-grey-100);
  margin-bottom: 3px;
  text-decoration: line-through;
`;

const checkboxCss = css`
  ${TextBody2RRMixin};
  margin-bottom: 8px;
  color: var(--general-grey-100);
`;
